export default __webpack_public_path__ + "static/media/hero_full.f3cd29ec.webp";